module.exports = __webpack_public_path__ + "media/images/bg-bonds1-e6ea828d00efd77ac31f5bb84b0f6306.jpg";